"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getHeightExcludingBanner = require("./getHeightExcludingBanner");
Object.keys(_getHeightExcludingBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getHeightExcludingBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getHeightExcludingBanner[key];
    }
  });
});
var _branding = require("./branding");
Object.keys(_branding).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _branding[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _branding[key];
    }
  });
});